import { lazy, Suspense, useState } from "react";
import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import Holiday from "./page/holiday";
import Salary from "./page/Salary";
import Expenses from "./page/Expenses";
import AssignTasks from "./page/AssignTasks";
import LeaveApplications from "./page/LeaveApplications";
import Header from "./component/Header";
import Sidebar from "./component/Sidebar";
import FaceAttendance from "./page/faceattendance";
import Employee from "./page/employee";

// Router selection
const Router = process.env.REACT_APP_PRERENDER ? HashRouter : BrowserRouter;

// Lazy-loaded pages
const Dashboard2 = lazy(() => import("./page/Dashboard2"));
const Attendance = lazy(() => import("./page/Attendance"));

function App() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Router>
      <div className={`main-content ${collapsed ? "collapsed" : ""}`}>
        <Header onToggleSidebar={() => setCollapsed(!collapsed)} />

        <div className="app-layout">
          <Sidebar collapsed={collapsed} />

          <div className="page-content">
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                <Route path="/" element={<Dashboard2 />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/face" element={<FaceAttendance />} />
                <Route path="/employee" element={<Employee />} />
                <Route path="/salary" element={<Salary />} />
                <Route path="/holiday" element={<Holiday />} />
                <Route path="/tasks" element={<AssignTasks />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route
                  path="/leave-applications"
                  element={<LeaveApplications />}
                />
              </Routes>
            </Suspense>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;